const logoPaginaDofollow = 'Logo en la página del programa en TNO Network (sección Anunciantes) con enlace dofollow.';

const optionsData = [
  {
    title: 'Sponsorship Vida Inmobiliaria',
    annualPrice: 'Trimestral: 360',
    monthlyPrice: 120,
    features: [
      'Tres menciones en vivo: al entrar, en el desarrollo (aquí se explica tu marca) y salida',
      'Video comercial de 20 segundos durante el programa',
      'Presencia en transmisión en vivo por TNO Network',
      'Presencia en Web, App y Redes Sociales',
      'Asociación con mercado inmobiliario, inversión y patrimonio',
      logoPaginaDofollow,
    ],
    idealFor: 'Inmobiliarias, constructoras, bancos, seguros y marcas del ecosistema hogar.',
    duration: 'Mensual',
    buttonText: 'Patrocinar Vida Inmobiliaria',
    highlightedTitle: 'Inmobiliario Multiplataforma',
    highlightedContent: [
      'Tu marca en el programa referente del sector en TNO Network.',
      'Tres menciones + un comercial de 20 segundos dentro del programa.',
      'Compra, inversión y desarrollo en un solo espacio.',
    ],
    highlightedButtonText: 'Ver Demo del Programa',
  },
  {
    title: 'Segmento Exclusivo por Tema',
    annualPrice: 'Trimestral: 180',
    monthlyPrice: 60,
    features: [
      'Mención exclusiva: "Este segmento presentado por..."',
      'Vinculación con una temática: Compra/Venta, Inversión, Financiamiento o Proyectos',
      'Contenido alineado con el ADN de tu marca',
      'Presencia en el bloque correspondiente del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas especializadas que buscan relevancia en un nicho inmobiliario.',
    duration: 'Suscripción Mensual',
    buttonText: 'Elegir mi Tema',
    highlightedTitle: 'Autoridad en el sector',
    highlightedContent: [
      'Tu marca como referente del segmento elegido.',
      'Asociación orgánica con decisiones patrimoniales informadas.',
      'Ideal para lanzamientos de proyectos y campañas B2B.',
    ],
    highlightedButtonText: 'Ver Temas Disponibles',
  },
  {
    title: 'Entrevista Patrocinada',
    annualPrice: 'Por sesión: 40',
    monthlyPrice: 40,
    features: [
      'Entrevista de 20 minutos en vivo',
      'Proyección de tus videos promocionales',
      'Mención de proyectos, sedes o puntos de contacto',
      'Propuesta con respaldo visual en pantalla',
      'Post en redes sociales del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Desarrolladores, corredores, estudios legales y voceros de marca inmobiliaria.',
    duration: '20 minutos por sesión',
    buttonText: 'Agendar Entrevista',
    highlightedTitle: 'Proyección y respaldo visual',
    highlightedContent: [
      'Proyección de videos promocionales durante la entrevista.',
      'Mención de oferta con respaldo en pantalla.',
    ],
    highlightedButtonText: 'Consultar Fechas',
  },
  {
    title: 'Post Patrocinado en TNO Digest',
    annualPrice: 'Por publicación: 50',
    monthlyPrice: 50,
    features: [
      'Publicación patrocinada en las redes sociales de TNO Digest',
      'Alcance en el ecosistema digital de Vida Inmobiliaria y TNO Digest',
      'Contenido adaptado a inmobiliario y lifestyle residencial',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan visibilidad en redes sin compromiso de programa en vivo.',
    duration: 'Por publicación',
    buttonText: 'Solicitar Post Patrocinado',
    highlightedTitle: 'Visibilidad en TNO Digest',
    highlightedContent: [
      'Tu marca en el feed oficial de TNO Digest.',
      'Ideal para lanzamientos o reforzar una campaña.',
    ],
    highlightedButtonText: 'Solicitar Post',
  },
  {
    title: 'Cápsula Inmobiliaria / Marca',
    annualPrice: 'Pack 5 Cápsulas: 150',
    monthlyPrice: 40,
    features: [
      'Cápsula de 60-90 segundos con estética del programa',
      'Distribución en redes sociales de TNO y del programa',
      'Tema: tips de mercado, proyecto o promoción',
      'Locución profesional en línea con el tono del show',
      logoPaginaDofollow,
    ],
    idealFor: 'Promociones de proyectos, ferias inmobiliarias y lanzamientos comerciales.',
    duration: 'Por cápsula',
    buttonText: 'Solicitar Cápsula',
    highlightedTitle: 'Atención en Redes',
    highlightedContent: [
      'Tu mensaje en el ecosistema de Vida Inmobiliaria.',
      'Formato breve y memorable para máxima recordación.',
    ],
    highlightedButtonText: 'Enviar mi Propuesta',
  },
  {
    title: 'UGC Inmobiliario',
    annualPrice: '80 por pieza',
    monthlyPrice: 80,
    features: [
      'Video estilo recorrido, testimonio o caso de éxito con el producto',
      'Demostración en contexto de hogar, oficina o proyecto',
      'Narrativa humana alineada con patrimonio y confianza',
      'Publicación del video en TNO y en Vida Inmobiliaria',
      'Entrega de archivo original para pauta publicitaria de la marca',
      logoPaginaDofollow,
    ],
    idealFor: 'Constructoras, inmobiliarias, retail del hogar y servicios financieros.',
    duration: 'Por pieza',
    buttonText: 'Activar Campaña UGC',
    highlightedTitle: 'Prueba social inmobiliaria',
    highlightedContent: [
      'Contenido UGC con tono del programa y credibilidad sectorial.',
      'Tu marca como recomendación de un aliado, no como anuncio frío.',
    ],
    highlightedButtonText: 'Activar Campaña UGC',
  },
];

export default optionsData;
